module.exports = __webpack_public_path__ + "static/media/progress1.0f5865fd.png";